import { QUERY_DELETE_DELETEMODEL, QUERY_GET_MODELS, QUERY_GET_MODELSPAG, QUERY_POST_CREATEMODEL, QUERY_PUT_EDITMODEL} from '../../fetch/constantQueries'
import { baseThunk, getUrl } from '../../fetch/basicThunk';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchDelete, fetchPut } from '../../fetch/fetchConfig';

export const getModels = baseThunk(`models/getModels`, QUERY_GET_MODELS, "GET");
export const getModelsPag = baseThunk(`models/getModelsPag`, QUERY_GET_MODELSPAG, "GET");

export const createModel = baseThunk("models/create", QUERY_POST_CREATEMODEL, "POST");
export const deleteModel = baseThunk("models/delete", QUERY_DELETE_DELETEMODEL, "DELETE");
export const editModel = baseThunk("models/dupdate", QUERY_PUT_EDITMODEL, "PUT");
